app.controller("ChangeMailController", ["$scope", "AuthService", "$stateParams", "$state",
    function ($scope, AuthService, $stateParams, $state) {
        $scope.status = null;
        $scope.resend = $stateParams.resend;

        AuthService.getUserData().then(function (user) {
            $scope.userEmail = user.email;
        });

        $scope.submit = function () {
            if ($scope.email.indexOf('@sangu.edu.ge') === -1) {
                $scope.status = 'only_internal';
                return;
            }
            if ($scope.email) {
                AuthService.changeEmail({email: $scope.email}).then(function () {
                    $scope.status = 'success';
                }).catch(function () {
                    $scope.status = 'error';
                });
            }
        };

        $scope.resendMail = function () {
            AuthService.getUserData().then(function (user) {
                AuthService.changeEmail({email: user.email}).then(function () {
                    $scope.status = 'success';
                }).catch(function () {
                    $scope.status = 'error';
                });
            });

        }

        $scope.goBack = function () {
            var profiles = {
                'student': 'student-new.profile',
                'rest': 'profile'
            };
            if ($stateParams.profile.length > 0) {
                $state.go(profiles[$stateParams.profile]);
            } else {
                $state.go('login');
            }
        };

        $scope.goToMailChange = function () {
            $state.go('change-mail', {resend: ''});
        }
    }
]);
